module.exports = __webpack_public_path__ + "img/x-twitter-brands.cd8ceff5.svg";